import { VivaISVTurnover } from '../constants/isv';
import { API_URL } from '../environment';
import { Integration, IntegrationViva, IntegrationPersonalkollen } from '../model/Integration';
import fetcher from '../utils/fetcher';

export const getIntegrationsList = async (companyId: string) => {
  return fetcher(`${API_URL}/v1/company/${companyId}/integrations`, {
    method: 'GET',
  }).then((data) => data as Integration[]);
};

export const createVivaIntegration = async (
  companyId: string,
  data: {
    turnover: VivaISVTurnover;
    terminalFee: number;
  },
): Promise<{ integrationId: string }> => {
  return fetcher(`${API_URL}/v1/company/${companyId}/integrations/viva`, {
    method: 'POST',
    data: JSON.stringify(data),
  });
};

export const createPersonalkollenIntegration = async (
  companyId: string,
  apiKey: string,
): Promise<{ integrationId: string }> => {
  return fetcher(`${API_URL}/v1/company/${companyId}/integrations/personalkollen`, {
    method: 'POST',
    data: JSON.stringify({ apiKey }),
  }).then((data) => data);
};

export const getVivaIntegrationStatus = async (
  companyId: string,
  integrationId: string,
): Promise<{ status: string }> => {
  return fetcher(`${API_URL}/v1/company/${companyId}/integrations/viva/${integrationId}`, {
    method: 'GET',
  }).then((data) => data);
};

export const updateVivaIntegration = async (
  companyId: string,
  integrationId: string,
  data: Partial<IntegrationViva>,
): Promise<void> => {
  return fetcher(`${API_URL}/v1/company/${companyId}/integrations/viva/${integrationId}`, {
    method: 'PUT',
    data: JSON.stringify(data),
  });
};

export const updatePersonalkollenIntegration = async (
  companyId: string,
  integrationId: string,
  data: Partial<IntegrationPersonalkollen>,
): Promise<void> => {
  return fetcher(
    `${API_URL}/v1/company/${companyId}/integrations/personalkollen/${integrationId}`,
    {
      method: 'PUT',
      data: JSON.stringify(data),
    },
  );
};
